import script from "./web-exhibition.vue?vue&type=script&setup=true&lang=js"
export * from "./web-exhibition.vue?vue&type=script&setup=true&lang=js"

import "./web-exhibition.vue?vue&type=style&index=0&id=222b1f10&lang=scss"

const __exports__ = script;

export default __exports__